import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Stage3Heirarchy from "./Stage3Heirarchy";
import Stage3CheckboxList from "./Stage3CheckboxList";
import ItemList from "./Stage3SelectedItems";
import { useFormContext } from './FormContext'

function Stage3DataPanel(props) {
  const { formData, updateFormData } = useFormContext();
  const [selectedItems, setSelectedItems] = useState(()=>{  
    if(props.zone.zoneId == 1){
      if(!formData?.stage3?.products){

        updateFormData("stage3", {
          ...formData.stage3,
          products: [],
        });
        
        return [];
      }else{
        return formData?.stage3?.products;
      }      
    }else if(props.zone.zoneId == 2){
      if(!formData?.stage3?.geography){

        updateFormData("stage3", {
          ...formData.stage3,
          geography: [],
        });

        return [];
      }else{
        return formData?.stage3?.geography;
      } 
    }
  });
  const [selectedTreeNode, setSelectedTreeNode]= useState(null);

  return (
    <Wrapper>
      <div className="datatab">
        <div id="productheirarchy">
          <div className="col-md-4 col-sm-4 col-xs-12">
            <div className="productbox1">
              <h4>{props.heirarchyHeaderName}</h4>
              <div className="displayproducttab">
                <Stage3Heirarchy
                  heirarchyData={props.heirarchyData}
                  setSelectedTreeNode={setSelectedTreeNode}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-4 col-xs-12">
            <div className="productbox1">
              <h4>{props.zoneHeaderName}</h4>
              <Stage3ChoiceList
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                heirarchyHeaderName={props.heirarchyHeaderName}
                zoneHeaderName={props.zoneHeaderName}
                selectedTreeNode={selectedTreeNode}
                zone={props.zone}
              />              
            </div>
          </div>
          <div className="col-md-4 col-sm-4 col-xs-12">
            <div className="productbox2">
              <h4>{`SELECTED ${props.zone.zoneId === 1 ? 'SKUS' : 'LOCATIONS'} ` }<span>{`(${selectedItems?.length})`}</span></h4>
              <div className="">
                <ItemList
                  selectedItems={selectedItems}
                  setSelectedItems={setSelectedItems}
                  zone={props.zone}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default Stage3DataPanel;

function Stage3ChoiceList({
  choosenItems,
  selectedItems,
  setSelectedItems,
  heirarchyHeaderName,
  selectedTreeNode,
  zone
}) {
  const [searchString, setSearchString] = useState("");

  const handleSearchOnChange = (e) => {
    const { value } = e.target;
    setSearchString(value);
  };

  return (
    <>
      <div className="dataselectsearhbar">
        <input
          type="text"
          className="form-control"
          id="search"
          placeholder="Search Here"
          onChange={handleSearchOnChange}
        />

        <iconify-icon icon="material-symbols:search"></iconify-icon>
      </div>
      <div className="displayproducttab2">
        <Stage3CheckboxList
          data={choosenItems}  
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          heirarchyHeaderName={heirarchyHeaderName}
          searchString={searchString}
          selectedTreeNode={selectedTreeNode}
          zone={zone}
        />
      </div>
    </>
  );
}

const Wrapper = styled.div`
  .displayproducttab {
    color: #000;
    font-weight: 600;
    font-size: 16px;
    text-transform: uppercase;
  }
`;
